<template>
  <main class="page">
    <section class="section page__header">
      <div class="page__row page__row_between">
        <div class="page__item">
          <h1 class="title">Статусы</h1>
        </div>
        <div class="page__item">
          <AppButtonSmAdd title="Создать" @click.native="showCreateModal" />
        </div>
      </div>
    </section>

    <section class="section page__content">
      <div class="page__row mb-20" v-if="statuses.length !== 0">
        <AppTable :data="statuses"
                  :headers="tableHeaders"
                  :isMenuControlsActive="roleAccessRemove"
                  @show-this-item="showUpdateModal"
                  @toggle-controls="showRemoveConfirmation"
        />
      </div>
      <div class="page__row mb-20" v-else>
        <div class="no-records">
          <AppNoRecordsPlaceholder text="В разделе еще нет ни одной записи"/>
        </div>
      </div>
    </section>

    <section class="section page__footer directory-list__footer">
      <div class="page__row">
        <!--место для пагинации-->
      </div>
    </section>

    <transition-group name="fade">
      <AppConfirmation v-if="removeConfirmation.active"
                       key="remove-confirmation"
                       text="Вы действительно хотите удалить этот статус?"
                       @confirm="removeItem"
                       @reject="closeModals"
      />
      <ItemUpdateModal v-if="updateModal.active"
                       key="update-modal"
                       title="Редактировать статус"
                       :item="updateModal.status"
                       :name-validation="updateModal.validation"
                       @set-item-name="setItemUpdatedName"
                       @update-item="updateItem"
                       @close-modal="closeModals"
      />
      <ItemCreateModal v-if="createModal.active"
                       key="create-modal"
                       title="Создать статус"
                       :value="createModal.newStatusName"
                       :name-validation="createModal.validation"
                       @set-item-name="setNewItemName"
                       @create-item="createItem"
                       @close-modal="closeModals"
      />
    </transition-group>
    <ThePagePreloader v-if="isLoading"/>
  </main>
</template>

<script>
import AppTable from '../../../components/page/table/AppTable'
import AppConfirmation from '../../../components/page/modal/AppConfirmation'
import AppButtonSmAdd from '../../../components/page/button/AppButtonSmAdd'
import ThePagePreloader from '../../../components/page/ThePagePreloader'
import ItemUpdateModal from '../../../components/page/modal/itemUpdateModal'
import ItemCreateModal from '../../../components/page/modal/itemCreateModal'
import AppNoRecordsPlaceholder from '../../../components/page/text/AppNoRecordsPlaceholder'

export default {
  name: 'StatusList',
  components: {
    AppNoRecordsPlaceholder,
    ItemCreateModal,
    ItemUpdateModal,
    ThePagePreloader,
    AppButtonSmAdd,
    AppConfirmation,
    AppTable
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        id: null
      }
    }
  },
  computed: {
    statuses () {
      const statuses = this.$store.getters.statuses
      const statusesData = []
      for (let i = 0; i < statuses.length; ++i) {
        statusesData.push({
          id: statuses[i].id,
          isControlsActive: statuses[i].isControlsActive,
          values: [
            statuses[i].name
          ]
        })
      }
      return statusesData
    },
    isLoading () {
      return this.$store.getters.statusListIsLoading
    },
    tableHeaders () {
      return this.$store.getters.statusListTableHeaders
    },
    updateModal () {
      return this.$store.getters.statusListUpdateModal
    },
    createModal () {
      return this.$store.getters.statusListCreateModal
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightContracts.actions.remove
    }
  },
  methods: {
    toggleItemControls (itemId) {
      this.$store.dispatch('toggleStatusListItemControls', itemId)
    },
    showCreateModal () {
      this.$store.dispatch('showStatusListCreateModal')
    },
    setNewItemName (name) {
      this.$store.dispatch('setCreatedStatusName', name)
      this.$store.dispatch('clearStatusListModalValidation')
    },
    createItem () {
      this.$store.dispatch('createStatus')
    },
    showUpdateModal (itemId) {
      this.$store.dispatch('showStatusListUpdateModal', itemId)
    },
    setItemUpdatedName (name) {
      this.$store.dispatch('setUpdatedStatusName', name)
      this.$store.dispatch('clearStatusListModalValidation')
    },
    updateItem () {
      this.$store.dispatch('updateStatus')
    },
    showRemoveConfirmation (itemId) {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = itemId
    },
    removeItem () {
      this.$store.dispatch('deleteStatus', this.removeConfirmation.id)
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    closeModals () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
      this.$store.dispatch('closeStatusListModals')
      this.$store.dispatch('clearStatusListModalValidation')
    }
  },
  mounted () {
    this.$store.dispatch('getStatuses')
  }
}
</script>

<style lang="scss" scoped>
.directory-list {
  &__footer {
    padding-bottom: 110px;
  }
}

.no-records {
  width: 100%;
  margin-top: 80px;
}
</style>
